import PackagesTable from "./packages-table";

export default PackagesTable;
